//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import cmFooter from '@/components/cmFooter.vue'
export default {
  name: 'factory',
  components: {
      cmFooter
  },
  data () {
    return {
      info:{},
      nav:[
          {
          title:'入厂',
          path:'/inFactory/0',
          auth:'inFactory',
          img:'/static/images/inFactory.png',
        },
         {
          title:'打包',
          path:'/inFactory/1',
          auth:'pack',
          img:'/static/images/pack.png',
        },
         {
          title:'出厂',
          path:'/inFactory/2',
          auth:'outMaxFactory',
          img:'/static/images/outMaxFactory.png',
        },
        {
          title:'条码查询',
          path:'/barOrder',
          auth:'barOrder',
          img:'/static/images/bar.png',
        },
        {
          title:'订单查询',
          path:'/searchOrder',
          auth:'searchOrder',
          img:'/static/images/searchOrder.png',
        },
        {
          title:'不洗退回',
          path:'/factoryBack',
          auth:'factoryBack',
          img:'/static/images/factoryBack.png',
        },
        {
          title:'异常报备',
          path:'/abnormal',
          auth:'abnormal',
          img:'/static/images/abnormal.png',
        },
        {
          title:'物流订单',
          path:'/waybillOrder',
          auth:'waybillOrder',
          img:'/static/images/express.png',
        },
        {
          title:'衣物发货',
          path:'/waybillClotheOrder',
          auth:'waybillClotheOrder',
          img:'/static/images/topic-online2.png',
        },
        {
          title:'物流轨迹',
          path:'/queryExpress',
          auth:'queryExpress',
          img:'/static/images/send_back.png',
        },
        // {
        //   title:'订单发货',
        //   path:'/waybillSendOrder',
        //   auth:'waybillSendOrder',
        //   img:'/static/images/express.png',
        // },
      ]
    }
  },
  created(){
    if(this.$func.getLocal('token')){
      this.getCount();
    }else{
      this.$router.push({path:'/login'})
    }
  },
  mounted(){
  },
  methods:{
    getCount(){
      this.$api.factoryData({}).then((res)=>{
        this.info = res.data;
      })
    },
  }
}



// WEBPACK FOOTER //
// ./src/pages/factory.vue